"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _nuiIntl = _interopRequireWildcard(require("@concur/nui-intl"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var ListingsActions = _interopRequireWildcard(require("./listingsModule"));

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/listings.css") : void 0;

var _Header = _interopRequireDefault(require("../shared/Header"));

var _CommonSections = _interopRequireDefault(require("../shared/CommonSections"));

var _utils = require("../utils");

var _withAppContext = require("../HOCs/withAppContext");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Home =
/*#__PURE__*/
function (_Component) {
  _inherits(Home, _Component);

  function Home() {
    _classCallCheck(this, Home);

    return _possibleConstructorReturn(this, _getPrototypeOf(Home).apply(this, arguments));
  }

  _createClass(Home, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var categorySlug = (0, _get2.default)(this.props, 'params.category');
      if (categorySlug) this.props.setCategorySlug(categorySlug);

      if (this.props.context.isPublic && (0, _utils.canUseDOM)() && window.utag) {
        (0, _utils.sendPublicView)();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var categorySlug = (0, _get2.default)(this.props, 'params.category');

      if (categorySlug) {
        if (this.props.listings.categories.length > 0) {
          var isValidCategory = this.props.listings.categories.some(function (category) {
            var subCategoryMatch = false;

            if (category.subcategories.length > 0) {
              subCategoryMatch = category.subcategories.some(function (subCategory) {
                return subCategory.slug.toLowerCase() === categorySlug.toLowerCase();
              });
            }

            return subCategoryMatch || category.slug.toLowerCase() === categorySlug.toLowerCase();
          });
          if (!isValidCategory) window.location = '/404';
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var localeData = (0, _nuiIntl.getLocaleData)(this.props);

      var translations = window.NUI_TRANSLATIONS; // eslint-disable-line global-require, import/no-dynamic-require


      return _react.default.createElement(_nuiIntl.default, {
        messages: translations,
        localeData: localeData
      }, _react.default.createElement("div", null, _react.default.createElement(_Header.default, {
        enableLiveSearch: true
      }), _react.default.createElement(_CommonSections.default, {
        enableLiveUpdate: true
      })));
    }
  }]);

  return Home;
}(_react.Component);

Home.propTypes = {
  listings: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  setCategorySlug: _propTypes.default.func
};

function mapStateToProps(state) {
  return {
    listings: state.listings,
    userPrefs: state.userPrefs
  };
}

var _default = (0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, {
  setCategorySlug: ListingsActions.setCategorySlug
})(Home));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listings/ListingsContainer.js
// module id = 240
// module chunks = 0